import { isPossiblePhoneNumber } from 'react-phone-number-input';

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// More permissive URL regex that allows simple domains like "example.com"
export const urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
export const phoneNumberRegex = /^\+?(\d{1,4})?[\s-]?(\(?\d{1,4}\)?)?[\s-]?(\d{1,4})[\s-]?(\d{1,4})[\s-]?(\d{1,9})$/;


// Pure Validation Function (Takes form data and returns errors)
// This is the core logic you'll reuse.
export const validateStep1Info = (formData, currentStep) => {
  const newErrors = {};
  if (currentStep === 1) {
    // Basic Required Field Checks (Custom 'required1')
    if (!formData.first_name?.trim()) {
      newErrors.first_name = 'First Name is required.';
    }
    if (!formData.last_name?.trim()) {
      newErrors.last_name = 'Last Name is required.';
    }
    if (!formData.phone?.trim()) {
      newErrors.phone = 'Phone Number is required.';
    }
    else if (formData.phone && !isPossiblePhoneNumber(formData.phone)) {
      newErrors.phone = 'Invalid phone number format.';
    }
    if (!formData.domain?.trim()) {
      newErrors.domain = 'Domain is required.';
    }

    // Email Format Check
    if (!formData.email?.trim()) {
      newErrors.email = 'Email is required.';
    }
    else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Invalid email format.';
    }

    // Website URL Check
    if (!formData.website?.trim()) {
      newErrors.website = 'Website URL is required.';
    }
    else if (!urlRegex.test(formData.website)) {
      newErrors.website = 'Invalid URL format (must include http/https or be a valid domain).';
    }
  }

  return newErrors;
};

export const validateStep2AddressInfo = (formData, currentStep) => {
  const newErrors = {};
  if (currentStep === 2) {
    // Basic Required Field Checks (Custom 'required1')

    if (!formData.address?.trim()) {
      newErrors.address = 'Address is required.';
    }
    if (!formData.street?.trim()) {
      newErrors.street = 'Street is required.';
    }
    // if (!formData.street2.trim()) newErrors.street2 = 'Street2 is required.';
    if (!formData.city?.trim()) {
      newErrors.city = 'City is required.';
    }
    if (!formData.state?.trim()) {
      newErrors.state = 'State is required.';
    }
    if (!formData.country?.trim()) {
      newErrors.country = 'Country is required.';
    }
    if (!formData.zip_code?.trim()) {
      newErrors.zip_code = 'Zip code is required.';
    }
    if (!formData.recaptchaToken?.trim()) {
      newErrors.recaptchaToken = 'Recaptcha code is required.';
    }

    if (formData.email?.trim() && !emailRegex.test(formData.email.trim())) {
      newErrors.email = 'Please enter a valid email address.';
    }
  }
  return newErrors;
};

export const validateContent = (formData) => {
  const newErrors = {};

  // Basic Required Field Checks (Custom 'required1')
  // console.log(formData);
  if (!formData.name.trim()) {
    newErrors.name = 'Name is required.';
  }
  if (!formData.email.trim()) {
    newErrors.email = 'Email is required.';
  }
  if (!formData.subject.trim()) {
    newErrors.subject = 'Subject is required.';
  }
  if (!formData.message.trim()) {
    newErrors.message = 'Message is required.';
  }
  if (!formData.recaptchaToken.trim()) {
    newErrors.recaptchaToken = 'Recaptcha code is required.';
  }

  if (formData.email.trim() && !emailRegex.test(formData.email.trim())) {
    newErrors.email = 'Please enter a valid email address.';
  }

  return newErrors;
};

export const validateDemo = (formData) => {
  const newErrors = {};

  // Basic Required Field Checks (Custom 'required1')

  if (!formData.first_name.trim()) {
    newErrors.first_name = 'First name is required.';
  }
  if (!formData.last_name.trim()) {
    newErrors.last_name = 'Last name is required.';
  }
  if (!formData.email.trim()) {
    newErrors.email = 'Email is required.';
  }
  if (!formData.company.trim()) {
    newErrors.company = 'Company is required.';
  }
  if (formData.industry.trim() === '-') {
    newErrors.industry = 'Industry is required.';
  }
  if (formData.company_size.trim() === '-') {
    newErrors.company_size = 'Company size is required.';
  }
  if (!formData.modules_of_interest.trim()) {
    newErrors.modules_of_interest = 'Modules of interest is required.';
  }
  if (!formData.recaptchaToken.trim()) {
    newErrors.recaptchaToken = 'Recaptcha code is required.';
  }

  return newErrors;
};
